import { Avatar, Badge, Button, Dropdown, Icon, Input, Menu, Modal, Popover, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { inject, observer } from 'mobx-react';
import React, { ChangeEventHandler, Component } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { EncryptStore, NotificationStore, TokenStore, UserStore } from '../../stores';
import { NotificationDrawer } from './NotificationDrawer';



interface UserNavProps {
    userStore?: UserStore;
    notificationStore?: NotificationStore;
    tokenStore?: TokenStore;
    encryptStore?: EncryptStore;
}

const UserNavWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
`;

const UserNavItem = styled.span`
    padding: 0 12px;
    cursor: pointer;
    transition: all 0.3s;
    :hover {
        background: rgb(0, 0, 0, 0.025);
    }
`;

const UserNavIcon = styled(Icon)`
    font-size: 16px;
`;

const UserAvatar = styled(Avatar)`
    margin-top: 20px !important;
    vertical-align: top !important;
`;

const NoticeBadge = styled(Badge)`
    ${UserNavIcon} {
        padding: 4px;
    }
    sup {
        box-shadow: none !important;
    }
`;

const ButtonLoginStyled=styled.button`
    background-color:#575757 !important;
    border-color:#575757 !important;
    color:white !important;

    :hover{
        background-color:#bdbdbd !important;
        border-color:#bdbdbd !important;
    }
`;

@inject('userStore')
@inject('notificationStore')
@inject('tokenStore')
@inject('encryptStore')
@observer
export class UserNav extends Component<UserNavProps> {
    state = {
        visible: false
    };

    hide = () => {
        this.setState({
            visible: false
        });
    };

    handleVisibleChange = () => {
        this.setState({ visible: true });
    };

    async componentDidMount() {
        const { notificationStore, userStore, tokenStore } = this.props;
        if (sessionStorage.getItem('token') !== null) {
            tokenStore!.autenticado = true;
            tokenStore!.token = sessionStorage.getItem('token');
        }
        if (tokenStore!.autenticado) {
            await userStore!.getUsuario();
            if (userStore!.rol) {
                await notificationStore!.getNotifications(userStore!.rol);
            }
        }
    }

    handleSignOutClick = () => {
        // this.props.authStore!.logOut();
        this.props.tokenStore!.cerrarSesion();
        this.props.userStore!.limpiarUsuario();
    };

    handleDrawerClick = () => {
        this.props.notificationStore!.toggleDrawer();
    };

    setUsuario: ChangeEventHandler<HTMLInputElement> = event => {
        const { encryptStore, tokenStore } = this.props;
        // tokenStore!.usuario =  event.target.value;
        tokenStore!.usuario = encryptStore!.encriptar(event.target.value);
    };
    setPassword: ChangeEventHandler<HTMLInputElement> = event => {
        const { encryptStore, tokenStore } = this.props;
        // tokenStore!.password = event.target.value;
        tokenStore!.password = encryptStore!.encriptar(event.target.value);
    };

    iniciarSesion = async () => {
        const { notificationStore, userStore, tokenStore } = this.props;
        await tokenStore!.getToken();
        this.setState({
            visible: false
        });
        if (sessionStorage.getItem('token') !== null) {
            tokenStore!.autenticado = true;
            tokenStore!.token = sessionStorage.getItem('token');
        }
        if (tokenStore!.autenticado) {
            await userStore!.getUsuario();
            if (userStore!.rol) {
                await notificationStore!.getNotifications(userStore!.rol);
                await userStore!.getAcciones();
            }
        }
        return null;
    };

    render() {
        const { autenticado } = this.props.tokenStore!;
        const { username, rol } = this.props.userStore!;
        const { currentNotificationCount } = this.props.notificationStore!;
        let seeNotifications = rol && (rol.includes('ROO') || rol.includes('RM'));
        const { userStore } = this.props;
        seeNotifications = seeNotifications && userStore!.banderaPassword ? true : false;
        const stylePrimary = {
            backgroundColor:'#a8123e', borderColor:'#a8123e', marginTop: '15px', marginRight: '15px' 
        };
        const styleVeda = {
            backgroundColor:'#3c3c3b', borderColor:'#3c3c3b', marginTop: '15px', marginRight: '15px' 
        };
        const styleVedaSecondary = {
            backgroundColor:'#a7a7a7', borderColor:'#a7a7a7', marginTop: '15px'
        };
        const userDropdownMenu = (
            <Menu>
                <Menu.ItemGroup title={username} />
                <Menu.Divider />
                <Menu.Item onClick={this.handleSignOutClick}>Cerrar Sesión</Menu.Item>
            </Menu>
        );
        const contentPop = (
            <div>
                <Input
                    style={{ marginBottom: '15px' }}
                    placeholder="Usuario"
                    onChange={this.setUsuario}
                />
                <Input.Password placeholder="Contraseña" onChange={this.setPassword} />{' '}
                <div style={{ textAlign: 'right' }}>
                    <Button
                        type={'primary'}
                        style={stylePrimary}
                        onClick={this.iniciarSesion}
                        
                    >
                        Ingresar
                    </Button>
                    <Button type={'primary'} style={styleVedaSecondary} onClick={this.hide}>
                        Cancelar
                    </Button>
                </div>
            </div>
        );
        const principalTitle = (
            <div style={{float: 'left', marginTop: '15px', marginRight: '270px'}}>
                <Title level={3}>Sistema de Participaciones a Municipios</Title>
            </div>
        );

        return (
            <UserNavWrapper>
                {autenticado ? (
                    <>
                        {seeNotifications && (
                            <UserNavItem onClick={this.handleDrawerClick}>
                                <NoticeBadge count={currentNotificationCount}>
                                    <UserNavIcon type="bell" />
                                </NoticeBadge>
                            </UserNavItem>
                        )}
                        <Dropdown overlay={userDropdownMenu}>
                            <UserNavItem>
                                <a className="ant-dropdown-link" href="#">
                                    <UserAvatar size="small" icon="user" />
                                </a>
                            </UserNavItem>
                        </Dropdown>
                        {seeNotifications && (
                            <NotificationDrawer onClose={this.handleDrawerClick} />
                        )}
                    </>
                ) : (
                    
                    <div >
                        {principalTitle}
                        <Popover
                            trigger={'click'}
                            placement={'bottomRight'}
                            content={contentPop}
                            visible={this.state.visible}
                            onVisibleChange={this.handleVisibleChange}
                        >
                            <ButtonLoginStyled className={'ant-btn'}  >Iniciar Sesión</ButtonLoginStyled>
                        </Popover>
                    </div>
                )}
            </UserNavWrapper>
        );
    }
}
